























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import XDialog from '@finance/ssvue/src/components/x-dialog/index.vue'
import requestBackActionNotify from '@common/client/src/requestBackActionNotify'
import closeView from '@common/client/src/closeView'
import useragent from '@finance/useragent'
import { matchToday } from '@common/loan-act/util'
import IconTitle from '$components/icon-title'
import Reporter from '$services/user-reporter'
import { ACT_CODE } from '$services/free-order'

const actModule = namespace('freeOrder')

// 返回上报工具
const backReporter = new Reporter(ACT_CODE, `${ACT_CODE}_BACK_NODE_CODE`)

@Component({
  name: 'stay-pop',
  components: {
    IconTitle,
    XDialog
  }
})
export default class RulePop extends Vue {
  @actModule.Getter actConfig!: any
  value = false;

  handleClickClose() {
    this.value = false
  }

  leave() {
    this.$Collect.trackEvent('2020双12火力红包页面_挽留弹窗_残忍离开')
    this.handleClickClose()
    closeView()
  }
  // 返回键劫持
  appBackBtn() {
    // 随手记
    if (useragent.isSuishouji) {
      requestBackActionNotify(() => {
        this.appBackBtnHandle()
      })
    }
  }
  // 返回键劫持事件
  appBackBtnHandle() {
    backReporter.get().then((data: any) => {
      console.log(data)
      const flag = data.find((e: any) => matchToday(e.createTime))
      console.log('flag', flag)
      if (!flag) {
        this.$Collect.trackView('2020双12火力红包页面_挽留弹窗_浏览')
        this.value = true
        backReporter.set()
      } else {
        closeView()
      }
    }).catch(() => {
      closeView()
    })
  }

  mounted() {
    this.appBackBtn()
  }
}
